import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI, Routing } from "../../api";
import '../dialog/dialog';
import { DialogViewModel } from '../dialog/dialog';
import { DataTableViewModel, IntermediateListItem, Color } from '../dataTable/dataTable';

import { MainViewModel } from "../../main";
import { Utils } from "../../utils";

export class SettingsViewModel {

    //KO Arrays
    users = ko.observableArray([]);
    anreden = ko.observableArray(['Herr', 'Frau', 'Herr Dr.', 'Frau Dr.']);
    rollen = ko.observableArray(["Anwalt", "ReFa"]);
    inboxes = ko.observableArray([]);

    //Status Modal
    statusModalTitle = ko.observable("");
    statusModalText = ko.observable("");
    statusText = ko.observable(""); //Normaler Text
    statusVisible = ko.observable(false);
    currentUserSymbol = ko.observable();


    //Neuen Benutzer anlegen
    newCreateUser() {
        let obj = {
            Anrede: ko.observable(null),
            Vorname: ko.observable(null),
            Nachname: ko.observable(null),
            Telefon: ko.observable(""),
            EMail: ko.observable(null),
            Rolle: ko.observable(""),
            Benutzer: ko.observable(null),
            Passwort: ko.observable(null),
            PasswortRetry: ko.observable(null),
            Recherche_EMail: ko.observable(""),
            Recherche_Passwort: ko.observable(""),
            Recherche_PasswortRetry: ko.observable("")

        };

        return ko.observable(obj);
    };
    createUser = this.newCreateUser();


    //Benutzer bearbeiten
    newEditUser() {
        let obj = {
            Anrede: ko.observable(null),
            Vorname: ko.observable(null),
            Nachname: ko.observable(null),
            Telefon: ko.observable(""),
            EMail: ko.observable(null),
            Rolle: ko.observable(""),
            Benutzer: ko.observable(null),
            Passwort: ko.observable(""),
            PasswortRetry: ko.observable(""),
            Recherche_EMail: ko.observable(""),
            Recherche_Passwort: ko.observable(""),
            Recherche_PasswortRetry: ko.observable("")

        };

        return ko.observable(obj);
    };
    editUser = this.newEditUser();


 

    protocols = [
        {
            name: "POP3",
            value: 0
        },
        {
            name: "IMAP",
            value: 1
        }
    ];

    newBasicInbox() {
        let obj = {
            "EMailAccount_ID": ko.observable(""),
            "EMail_Address": ko.observable(""),
            "IN_ProtokollType": ko.observable(1),
            "IN_UserLogin": ko.observable(""),
            "IN_UserPassword": ko.observable(""),
            "IN_Host": ko.observable(""),
            "IN_Port": ko.observable(993),
            "IN_ImapFolder": ko.observable("Inbox"),
            "IN_Authentification": ko.observable(1),
            "OUT_ProtokollType": ko.observable(0),
            "OUT_UserLogin": ko.observable(""),
            "OUT_UserPassword": ko.observable(""),
            "OUT_Host": ko.observable(""),
            "OUT_Port": ko.observable(465),
            "OUT_Authentification": ko.observable(0),
            "checkCertificate": ko.observable(true),
            "DeleteAfterDownload": ko.observable(false),
            "UnseenOnly": ko.observable(false),
            "GrabMails": ko.observable(true),
            "IsAutoInsertAddress": ko.observable(true)
        };

        return ko.observable(obj);
    };
    IsEditMode = ko.observable(false);
    inbox = this.newBasicInbox()

   
    //Views
    currentView: KnockoutObservable<String>;
    


    public showUsers() {
        MainViewModel.RoutingTable.showSettingsView({ view: "users" }, true);
        this.currentView('users');
    }

    public showZPEMail() {
        MainViewModel.RoutingTable.showSettingsView({ view: "zpemail" }, true);
        this.currentView('zpemail');
    }


        //this.language([0])

    
    /* ZPE Mails */
    async loadInboxes() {
        let inboxes = await RNSAPI.getAllInboxes();
        this.inboxes(inboxes.Payload.Accounts.map((inbox) => {
            inbox.actionHandlers = [{
                icon: "pencil-alt",
                name: "Edit",
                action: async () => {

                    let data = await RNSAPI.getInboxById(inbox.EMailAccount_ID);
                    this.inbox().EMailAccount_ID(inbox.EMailAccount_ID);
                    this.inbox().EMail_Address(data.Payload.EMail_Address);
                    this.inbox().IN_ProtokollType(data.Payload.IN_ProtokollType);
                    this.inbox().IN_UserLogin(data.Payload.IN_UserLogin);
                    this.inbox().IN_UserPassword(data.Payload.IN_UserPassword);
                    this.inbox().IN_Host(data.Payload.IN_Host);
                    this.inbox().IN_Port(data.Payload.IN_Port);
                    this.inbox().OUT_UserLogin(data.Payload.OUT_UserLogin);
                    this.inbox().OUT_UserPassword(data.Payload.OUT_UserPassword);
                    this.inbox().OUT_Host(data.Payload.OUT_Host);
                    this.inbox().OUT_Port(data.Payload.OUT_Port);
                    this.IsEditMode(true);
                    $("#createMail").modal('show');
                    
                }
            }, {
                icon: "trash-alt",
                name: "L�schen",
                action: async () => {
                    await RNSAPI.deleteInboxById(inbox.EMailAccount_ID);
                    this.loadInboxes();
                }
            }];
            return inbox;
        }));
        
    }

    async updateMail() {
        this.inbox().EMail_Address("");
        this.inbox().IN_ProtokollType(0);
        this.inbox().IN_UserLogin("");
        this.inbox().IN_UserPassword("");
        this.inbox().IN_Host("");
        this.inbox().IN_Port(993);
        this.inbox().OUT_UserLogin("");
        this.inbox().OUT_UserPassword("");
        this.inbox().OUT_Host("");
        this.inbox().OUT_Port(465);
        this.IsEditMode(false);
        $("#createMail").modal('show');
    }

    /* Weitere Benutzer */
    async updateData() {

        this.editUser().Benutzer(this.currentUserSymbol());


        if (!Utils.checkErrors(["Anrede", "Vorname", "Nachname", "EMail", "Benutzer", "Rolle"], this.editUser(), "", [Utils.checkString])) {
            this.statusText('Es wurden nicht alle erforderlichen Daten eingegeben.');
            this.statusVisible(true);
            return;
        }


        if (!Utils.checkErrors(["EMail"], this.editUser(), "", [Utils.checkEmail])) {
            this.statusText('Ung&uuml;ltiges E-Mail Adressen Format.');
            this.statusVisible(true);
            return;
        }

        if (this.editUser().Passwort() !== null && this.editUser().PasswortRetry() !== null) {
            if (this.editUser().Passwort() !== this.editUser().PasswortRetry()) {
                this.statusText('Die neu eingegebenen Passw&ouml;rter stimmen nicht &uuml;berein.');
                this.statusVisible(true);
                return;
            }
        }


        let result = await RNSAPI.updateLawFirmUser(this.editUser());
        if (result.Type === "UpdateUserSuccessful") {
            $("#editUser").modal('hide');
            this.statusModalTitle('<i class="far fa-check-circle  mr-2"></i> Erfolgreich');
            this.statusModalText('Der Benutzer <span class="text-default">' + this.editUser().Benutzer() + '</span> wurde erfolgreich bearbeitet.');
            $("#statusModal").modal('show');

        } else {
            this.statusText('Es ist ein Fehler aufgetreten.<br />Versuchen Sie es sp&auml;ter erneut oder kontaktieren Sie unseren Support unter info@rainmaker.de');
            this.statusVisible(true);
        }
    }


    async updateUsers() {
        let users = await RNSAPI.getLawFirmUsers();
        this.users(users.Payload.Users.map((c) => {
            c.actionHandlers = [
                {
                    icon: "pencil-alt", name: "Bearbeiten", action: async () => {
                        
                        let data = await RNSAPI.getLawFirmUser(c.Shorthandsymbol);
                        if (data.Type === "GetUserSuccessful") {

                            this.editUser().Anrede(data.Payload.User.Anrede);
                            this.editUser().Vorname(data.Payload.User.Vorname);
                            this.editUser().Nachname(data.Payload.User.Nachname);
                            this.editUser().Telefon(data.Payload.User.Telefon);
                            this.editUser().EMail(data.Payload.User.EMail);
                            this.editUser().Benutzer(data.Payload.User.Benutzer);
                            this.currentUserSymbol(data.Payload.User.Benutzer);
                            switch (data.Payload.User.Rolle) {
                                case "0":
                                    this.editUser().Rolle(this.rollen[0]);
                                    break;
                                case "1":
                                    this.editUser().Rolle(this.rollen[1]);
                                    break;
                            }
                            //this.editUser().Rolle(data.Payload.User.Rolle);
                            //this.editUser().Passwort(data.Payload.User.Passwort);
                            //this.editUser().PasswortRetry(data.Payload.User.PasswortRetry);
                            this.editUser().Recherche_EMail(data.Payload.User.Recherche_EMail);
                            this.editUser().Recherche_Passwort(data.Payload.User.Recherche_Passwort);
                            this.editUser().Recherche_PasswortRetry(data.Payload.User.Recherche_PasswortRetry);

                            $("#editUser").modal('show');

                        }
                        
                        //this.deadlineToBeModified(copy);
                        //$('#extendDeadline').modal('show');
                    }
                },
                {
                    icon: "trash-alt", name: "L�schen", action: async () => {
                        //this.deadlineToBeModified(copy);
                        //$('#delegateDeadline').modal('show');
                    }
                }
            ];
            return c;
        }));
    }


    async postData() {
        
        if (!Utils.checkErrors(["Anrede", "Rolle", "Vorname", "Nachname", "EMail", "Benutzer", "Passwort", "PasswortRetry"], this.createUser(), "", [Utils.checkString])) {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Es wurden nicht alle erforderlichen Daten eingegeben.');
            $("#statusModal").modal('show');
            return;
        }

        if (!Utils.checkErrors(["EMail"], this.createUser(), "", [Utils.checkEmail])) {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Ung&uuml;ltiges E-Mail Adressen Format.');
            $("#statusModal").modal('show');
            return;
        }

        if (this.createUser().Passwort.toString() !== this.createUser().PasswortRetry.toString()) {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Die eingegebenen Passw&ouml;rter stimmen nicht &uuml;berein.');
            $("#statusModal").modal('show');
            return;
        }


        //let test2 = ko.toJSON(this.createUser());
        //console.log(test2);

        let res = await RNSAPI.createLawFirmUser(this.createUser());
        if (res.Type === "CreateUserSuccessful") {
            this.statusModalTitle('<i class="far fa-check-circle mr-2"></i> Erfolgreich');
            this.statusModalText('Der Benutzer <span class="text-default">' + this.createUser().Vorname() + ' ' + this.createUser().Nachname() + '</span> wurde erfolgreich angelegt.');
            $("#statusModal").modal('show');
            this.createUser().Anrede("Herr");
            this.createUser().Vorname("");
            this.createUser().Nachname("");
            this.createUser().Telefon("");
            this.createUser().EMail("");
            this.createUser().Rolle("Anwalt");
            this.createUser().Benutzer("");
            this.createUser().Passwort("");
            this.createUser().PasswortRetry("");
            this.createUser().Recherche_EMail("");
            this.createUser().Recherche_Passwort("");
            this.createUser().Recherche_PasswortRetry("");
            this.update();
        } else {
            this.statusModalTitle('<i class="far fa-times-circle  mr-2"></i> Fehler');
            this.statusModalText('Der Benutzer mit dem K&uuml;rzel <b>' + this.createUser().Benutzer() + '</b> existiert bereits.<br />Bitte w&auml;hlen Sie einen anderen Benutzer aus.');
            $("#statusModal").modal('show');
        }

        //let test = await RNSAPI.getLawFirmUser("MG");
        //console.log(test);
        //try {

        //} catch (e) {

        //}

    }


    createInboxAccount = async () => {
        if (this.IsEditMode()) {
            let result = await RNSAPI.updateInbox(this.inbox());
            if (result.Type !== "InboxCreationSuccessful") {
                alert("Fehler beim Speichern!");
            } else {
                $("#createMail").modal('hide');
                this.loadInboxes();
            }
        } else {
            let result = await RNSAPI.createInbox(this.inbox());
            if (result.Type !== "InboxCreationSuccessful") {
                alert("Fehler beim Anlegen!");
            } else {
    
                $("#createMail").modal('hide');
                this.loadInboxes();

            }
        }
        this.IsEditMode(false);
    }

    loadInbox = async (id: string) => {
        let result = (await RNSAPI.getInboxById(id));
        let inbox = result.Payload;
        let tempInbox = this.inbox();
        for (let key in tempInbox) {
            if (tempInbox[key] === undefined) {
                tempInbox[key] = inbox[key];
            } else {
                tempInbox[key](inbox[key]);
            }
        }

        this.inbox(tempInbox);
    };

    async update() {
        this.updateUsers();
        this.loadInboxes();
    }


    constructor(params: any) {
        //if (params && params.id) {
        //    this.IsEditMode(true);
        //    this.loadInbox(params.id);
        //}
        this.inbox().EMail_Address.subscribe((newValue) => {
            if (this.inbox().IN_UserLogin() === "") this.inbox().IN_UserLogin(newValue);
            if (this.inbox().OUT_UserLogin() === "") this.inbox().OUT_UserLogin(newValue);
        });
        this.currentView = ko.observable(params.view);
        this.update();
    }
}


let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');

ko.components.register("settings-view", {
    viewModel: SettingsViewModel,
    template: html
});
 